<mat-card class="register-form-card">
  <mat-card-header>
    <mat-card-title i18n="formulaire admin utilisateur | titre">
      Utilisateur
    </mat-card-title>
    <mat-card-subtitle>
      @if (isUpdate) {
      <span i18n="formulaire admin utilisateur | sous-titre">
        mettre à jour
      </span>
      } @if (!isUpdate) {
      <span i18n="formulaire admin utilisateur | sous-titre">création</span>
      }
    </mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <form [formGroup]="form" (submit)="submit()">
      <p>
        <mat-form-field appearance="outline">
          <mat-label i18n="formulaire admin utilisateur | champ">
            prénom
          </mat-label>
          <input
            matInput
            placeholder="Jean-claude"
            formControlName="firstName"
          />
          <mat-icon matSuffix>person</mat-icon>
          <mat-error>
            @for (errorMsg of authMsg.firstName; track errorMsg) { @if
            (firstName.hasError(errorMsg.type)) {
            <span>
              {{ errorMsg.msg }}
            </span>
            } }
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label i18n="formulaire admin utilisateur | champ">nom</mat-label>
          <input
            matInput
            type="email"
            placeholder="Dusse"
            formControlName="lastName"
          />
          <mat-icon matSuffix>group</mat-icon>
          <mat-error>
            @for (errorMsg of authMsg.lastName; track errorMsg) { @if
            (lastName.hasError(errorMsg.type)) {
            <span>
              {{ errorMsg.msg }}
            </span>
            } }
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label i18n="formulaire admin utilisateur | champ">
            langue
          </mat-label>
          <mat-select matInput formControlName="lang">
            <mat-option value="fr">Francais</mat-option>
            <mat-option value="en">English</mat-option>
          </mat-select>
          <mat-icon matSuffix>language</mat-icon>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label i18n="formulaire admin utilisateur | champ">
            email
          </mat-label>
          <input
            matInput
            type="email"
            placeholder="jean-claude.dusse@mail.com"
            formControlName="email"
          />
          <mat-icon matSuffix>mail</mat-icon>
          <mat-error>
            @for (errorMsg of authMsg.email; track errorMsg) { @if
            (email.hasError(errorMsg.type)) {
            <span>
              {{ errorMsg.msg }}
            </span>
            } }
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label i18n="formulaire admin utilisateur | champ">
            password
          </mat-label>
          <input
            matInput
            [type]="showPassword ? 'text' : 'password'"
            placeholder="MonMotDePasse123!"
            formControlName="password"
          />
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="togglePassword()"
          >
            <mat-icon>
              {{ showPassword ? "visibility_off" : "visibility" }}
            </mat-icon>
          </button>
          <mat-error>
            @for (errorMsg of authMsg.password; track errorMsg) { @if
            (password.hasError(errorMsg.type)) {
            <span>
              {{ errorMsg.msg }}
            </span>
            } }
          </mat-error>
        </mat-form-field>
      </p>
      <mat-divider></mat-divider>
      <mat-card-actions>
        <button
          mat-flat-button
          type="button"
          (click)="cancel()"
          i18n="formulaire admin utilisateur | bouton"
        >
          annuler
        </button>
        <button
          mat-flat-button
          type="submit"
          color="primary"
          [disabled]="form.invalid"
        >
          @if (isUpdate) {
          <span i18n="formulaire admin utilisateur | bouton">
            mettre à jour
          </span>
          } @else {
          <span i18n="formulaire admin utilisateur | bouton">inscrire</span>
          }
        </button>
      </mat-card-actions>
    </form>
  </mat-card-content>
  <mat-card-footer>
    @if (formInProgress) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </mat-card-footer>
</mat-card>
